import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export type FinancialAgencyServices = 'leaseback' | 'refer_seller' | 'pro';

export type finanialAgencyLoginUserData = {
  id: number;
  email: string;
  name: string;
  financial_agency_id: number;
  financial_agency_division_details: { id: number; name: string }[];
  services: FinancialAgencyServices[];
};

export const finanialAgencyLoginUserDataAtom = atom<finanialAgencyLoginUserData | undefined>({
  key: 'finanialAgencyLoginUserDataAtom',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const hasMultipleDivisionsSelector = selector<boolean>({
  key: 'hasMultipleDivisionsSelector',
  get: ({ get }) => {
    const userData = get(finanialAgencyLoginUserDataAtom);

    if (userData) {
      return userData.financial_agency_division_details.length > 1;
    }

    return false;
  },
});
